import React from 'react';
import {IntlProvider} from 'react-intl';
import {Provider} from "react-redux";
import configureStore from './store';
import {PersistGate} from "redux-persist/integration/react";
import ReactDOM from 'react-dom';
import en from './messages/en';
import es from './messages/es';
import EQ from "./EQ";
import {flattenMessages,getCookie} from "./assets-static/scripts/utils";
import {BrowserRouter, Route, Switch} from "react-router-dom";

import 'intl'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-pluralrules/locale-data/es'

const messages = {'en': en,    'es': es}

const supportedLocales = ['en' , 'es'];
let locale = (getCookie('lang') && getCookie('lang'))
    || (navigator.languages && navigator.languages[0])
    || (navigator.language)
    || (navigator.userLanguage)
    || 'en';

locale = supportedLocales.includes(locale)? locale : 'en';

const {store, persistor} = configureStore()
ReactDOM.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <IntlProvider locale={locale} key={locale} messages={flattenMessages(messages[locale])}>
                <BrowserRouter>
                    <Switch>
                        <Route path="/fbgc/interactions/eq">
                            <EQ/>
                        </Route>
                    </Switch>
                </BrowserRouter>
            </IntlProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);
